export const BRANDS = [
    {
        id: "mamta",
        index: "01",
        name: "Mamta",
        tagline: "Our flagship drywall screws — the name contractors ask for.",
        image: "/assets/mamta.png",
        accent: "Blue ribbon series",
        products: [
            {
                name: "Drywall Screws",
                sizes: ['3/4"', '1"', '1.5"', '2"'],
                packing: "1 Carton = 20 Boxes",
                specs: ["High Strength", "Rust Resistant", "Precision Thread"],
            },
        ],
    },
    {
        id: "tigerstar",
        index: "02",
        name: "Tigerstar",
        tagline: "Screws, tape and fasteners — the complete drywall kit.",
        image: "/assets/tigerstar.png",
        accent: "Red & gold series",
        products: [
            {
                name: "Drywall Screws",
                sizes: ['1"', '1.5"', '2"'],
                packing: "1 Carton = 20 Boxes",
                specs: ["Best Quality", "Strong Hold"],
            },
            {
                name: "Drywall Tape 50m",
                sizes: ["50 metre roll"],
                packing: "1 Carton = 36 Pcs",
                specs: ["Joint Reinforcement"],
            },
            {
                name: "8mm Fastener",
                sizes: ["8 mm"],
                packing: "1 Carton = 20 Boxes",
                specs: ["Heavy Duty Fixing"],
            },
        ],
    },
    {
        id: "gripstar",
        index: "03",
        name: "Gripstar",
        tagline: "Rust-proof and tough — built for versatile application.",
        image: "/assets/gripstar.png",
        accent: "Red band series",
        products: [
            {
                name: "Drywall Screws",
                sizes: ['1"'],
                packing: "1 Carton = 20 Boxes",
                specs: ["Rust Proof", "Strong & Tough", "Versatile Application"],
            },
        ],
    },
    {
        id: "greypatta",
        index: "04",
        name: "Grey Patta",
        tagline: "Our premium quality brand — high-grade drywall screws with a grey phosphate coating for superior rust resistance and a cleaner finish.",
        image: "/assets/greypatta.jpg",
        accent: "Premium phosphate series",
        premium: true,
        products: [
            {
                name: "Drywall Screws — Grey Phosphate",
                sizes: ['1"'],
                packing: "1 Carton = 24 Boxes",
                specs: ["Premium Quality", "Grey Phosphate Coated", "Sharp Point", "Deep Thread", "Strong Hold"],
            },
        ],
    },
];

export const OTHER_PRODUCTS = [
    { name: "8mm Fasteners", desc: "Heavy-duty wall and frame fixing" },
    { name: "12mm Fasteners", desc: "Larger gauge anchoring jobs" },
    { name: "PVC", desc: "PVC fittings and accessories" },
    { name: "ND Screws", desc: "General-purpose fastening" },
    { name: "Connecting Clips", desc: "Channel and board connectors" },
    { name: "L Clips", desc: "Corner and angle support" },
];

export const ALL_PRODUCT_NAMES = [
    ...BRANDS.flatMap((b) => b.products.map((p) => `${b.name} — ${p.name}`)),
    ...OTHER_PRODUCTS.map((p) => p.name),
    "Other / Multiple Items",
];

export const CONTACT = {
    email: "mamtaenterpriises@gmail.com",
    phone: "8276078882",
    phoneIntl: "918276078882",
    location: "West Bengal, India",
};
